export default class ThirdPartyAuctionTracker {
  constructor (tracker, auctionId, transactionId) {
    this._tracker = tracker
    this._auctionId = auctionId
    this._transactionId = transactionId
    this._bidMap = { /* bidder code -> bidId */ }
  }

  bidRequest (bidder, media) {
    const bidId = this._tracker.genTransactionId()
    this._bidMap[bidder] = bidId

    this._tracker._onBidRequested({
      auctionId: this._auctionId,
      bids: [{
        transactionId: this._transactionId,
        mediaTypes: media,
        bidId,
        bidder
      }]
    })
  }

  addBidResponse (bidder, format, cpm, size) {
    this._tracker._onBidResponse({
      auctionId: this._auctionId,
      requestId: this._bidMap[bidder],
      mediaType: format,
      cpm,
      width: size && size.length ? size[0] : 0,
      height: size && size.length ? size[1] : 0
    })
  }

  bidWon (bidder, cleared) {
    return this._tracker.bidWon({
      requestId: this._bidMap[bidder],
      auctionId: this._auctionId
    }, cleared)
  }

  auctionId () {
    return this._auctionId
  }
}
